import { MFNavLink } from '@medifind/shared-basic-components';
import styles from './BoxNavigation.module.scss';

const BoxNavigation = ({ links = [], activeNavId }) => {
  return (
    <ul className={styles['nav']}>
      {links
        .filter((l) => l.href && l.name && l.id)
        .map(({ href, icon, id, name }, i) => (
          <li key={'li' + i} className={styles['nav-item']}>
            <MFNavLink to={href} className={styles['nav-link']} activeClassName={styles['is-active']} isActive={id === activeNavId} id={id}>
              {icon && <div className={styles['nav-icon']}>{icon}</div>}
              {name}
            </MFNavLink>
          </li>
        ))}
    </ul>
  );
};

export { BoxNavigation as default, BoxNavigation };
